<app-loading [progressBar]="progressBar" [spinner]="spinner"></app-loading>
<router-outlet></router-outlet>
<app-modal></app-modal>
